/**
 * Vehicle utilization rate KPI filters
 */
export class KpiVehicleUtilizationRateFilters {
	/**
	 * Period from date value
	 */
	periodFrom?: Date;

	/**
	 * Period to date value
	 */
	periodTo?: Date;
}
